import axios from "axios";

export function updateStockTake(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/distributor/admin/api/v1/stocktake/${parameters.id}/update`, {
        name: parameters.name,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
